export const urlScheme = {
    appStore: {
        name: 'App Store',
        pname: '',
        scheme: 'itms-apps://'
    },
    alipay: {
        name: '支付宝',
        pname: 'com.eg.android.AlipayGphone',
        scheme: 'alipay://'
    },
    taobao: {
        name: '淘宝',
        pname: 'com.taobao.taobao',
        scheme: 'taobao://'
    },
    qq: {
        name: 'QQ',
        pname: 'com.tencent.mobileqq',
        scheme: 'mqq://'
    },
    weixin: {
        name: '微信',
        pname: 'com.tencent.mm',
        scheme: 'weixin://'
    },
    jd: {
        name: '京东',
        pname: 'com.jingdong.app.mall',
        scheme: 'openApp.jdMobile://'
    },
    weibo: {
        name: '新浪微博',
        pname: 'com.sina.weibo',
        scheme: 'sinaweibo://'
    },
    youku: {
        name: '优酷',
        pname: 'com.youku.phone',
        scheme: 'youku://'
    }
}